import styled from 'styled-components'

export const StyledToastPortal = styled.div`
  &.top-center {
    top: 6rem;
    left: 58%;
  }
`
